var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',{staticClass:"tab",attrs:{"ripple":false,"active-class":"active"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('v-icon',{staticClass:"pr-1",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }